import { CasNotesField } from 'src/compass/shared/components';
import useCasBoolean from 'src/compass/shared/hooks/useCasBoolean';
import ClaimEditNotesDialog, { ClaimEditNotesDialogProps } from './ClaimEditNotesDialog';

type ClaimNotesFieldProps = Omit<ClaimEditNotesDialogProps, 'onClose'> & {
  value: string;
};

export default function ClaimNotesField({ label, value, ...rest }: ClaimNotesFieldProps) {
  const dialog = useCasBoolean();
  return (
    <>
      <CasNotesField fullWidth label={label} value={value} onClick={dialog.setTrue} />
      {dialog.value && <ClaimEditNotesDialog label={label} onClose={dialog.setFalse} {...rest} />}
    </>
  );
}
